cafm.treeView = {
    render: function (o) {

        var tvEl = $('#{0}'.format(o.ClientId));
        if (!tvEl.length) return;

        // set options on the tree view
        tvEl.data('options', o);

        var tvo = {};

        if (o.DataSourceUrl) {

            tvo.dataSource = cafm.ds.createTreeViewDataSource({
                element: tvEl,
                options: o
            });

            tvo.dataTextField = 'Description';
            tvo.loadOnDemand = true;
        }

        if (o.DataSourceUrl) {

            tvo.dataBound = cafm.treeView.loadOnDemandTreeDataBound;
        }
        else if (o.OnDataBound) {

            tvo.dataBound = cafm.util.getReference(o.OnDataBound);
        }

        var kTree = tvEl.kendoTreeView(tvo).data('kendoTreeView');
        
        if (o.SelectedDataKey) {

            kTree.collapse();

            if (!o.SelectedDataValue) {
                kTree.select($('.tvItem[data-key="{0}"]'.format(o.SelectedDataKey), tvEl));
            }
            else {
                kTree.select($('.tvItem[data-key="{0}"][data-value="{1}"]'.format(o.SelectedDataKey, o.SelectedDataValue), tvEl));
            }

            if (o.SelectedDataKey) {
                tvEl.data('activeDataKey', o.SelectedDataKey);
            }
            kTree.select().parents('.tvItem').addClass('tvActive');
        }

        cafm.treeView.displayItemCounts(kTree.element);

        $(kTree.element).off('dblclick').on('dblclick', function (e) {

            return false;
        });

        kTree.element.off('click').on('click', '.tvItem', function (e) {

            var targ = $(e.currentTarget),
                itemType = targ.data('itemtype'),
                filterPnl, key;

            if (o.FilterPanelClientId) {

                filterPnl = $('#{0}'.format(o.FilterPanelClientId));
            }

            key = targ.data('key');
            
            switch (itemType) {

                case cafm.enums.TreeViewItemType.DocumentFolder:
                case cafm.enums.TreeViewItemType.StandardWorkOrderGroup:

                    if ($(e.target).hasClass('k-icon')) {
                        return;
                    }

                case cafm.enums.TreeViewItemType.Item:

                    // make sure the click is on the text
                    if (!$(e.target).hasClass('k-in')) {

                        return;
                    }
                    else if (targ.data('url') && window.location != cafm.url.abs(targ.data('url'))) {

                        window.location = cafm.url.get(targ.data('url'));
                    }

                    break;

                case cafm.enums.TreeViewItemType.Navigatable:

                    $('#mobileMenu').hide();
                    if (!cafm.views.loadingMain) {
                        var val = targ.data('value');

                        if (cafm.nav.router) {

                            cafm.nav.router.navigate(key, val ? {
                                value: val
                            } : null);
                        }
                        break;
                    }
                    else {
                        return false;
                    }

                case cafm.enums.TreeViewItemType.FilterCategory:

                    cafm.filters.treeItemSelected(key, filterPnl);
                    break;

                case cafm.enums.TreeViewItemType.Filter:

                    cafm.filters.treeFilterSelected(key, filterPnl, targ.data('controltype'));
                    break;

                case cafm.enums.TreeViewItemType.FormCategory:

                    // if this is a re-press don't do anything as we don't want to collapse form section
                    if (targ.hasClass('tvActive')) {

                        e.preventDefault();
                        return false;
                    }

                    cafm.util.callFunctionAsync({
                        func: cafm.treeView.displayItemCounts,
                        arg1: tvEl
                    });
                    break;

                case cafm.enums.TreeViewItemType.LoadMore:
                    
                    kTree.loadMoreOnDemand({
                        item: targ
                    });
                    return;
            }

            // remove active CSS class from active item
            $('.tvActive', tvEl).removeClass('tvActive');

            // if navigatable or form category item
            if (itemType == cafm.enums.TreeViewItemType.Navigatable || itemType == cafm.enums.TreeViewItemType.FormCategory) {

                var adk = cafm.enums.Navigatable[key];
                if(!adk) {
                    adk = key;
                }
                tvEl.data('activeDataKey', adk);
            }

            // add active CSS class to item and parents
            targ.addClass('tvActive');
            targ.parents('.tvItem').addClass('tvActive');

            try {
                kTree.select(targ);
            }
            catch (err) { }

            cafm.handlers.exe(o.OnSelect, {
                item: targ,
                type: itemType,
                tree: kTree,
                mode: o.Mode,
                event: e
            });

            e.stopPropagation();
        });

        if (cafm.enums.isSingleEnumValue(o.Mode,  [cafm.enums.TreeViewMode.DocumentFolderSelection, cafm.enums.TreeViewMode.DocumentSelection, cafm.enums.TreeViewMode.StandardWorkOrderSelection])) {

            // double click handler for folders and swo groups
            kTree.element.off('dblclick').on('dblclick', '.tvFolder', function (e) {

                var targ = $(e.currentTarget);
                var itemType = targ.data('itemtype');

                if (cafm.enums.isSingleEnumValue(itemType, [cafm.enums.TreeViewItemType.DocumentFolder, cafm.enums.TreeViewItemType.StandardWorkOrderGroup])) {

                    kTree.toggle(targ);
                }

                return false;
            });
        }
    },
    displayNavTreeItemCounts: function () {

        cafm.treeView.displayItemCounts(nav.getNavTree());
    },
    displayItemCounts: function (treeElement) {

        $('[data-count]', treeElement).each(function (i, el) {

            var treeItem = $(el);
            var count = treeItem.data('count');
            cafm.treeView.displayItemCount(treeItem, count);
        });
    },
    displayItemCount: function (treeItem, count, updateData) {

        var kIn = $('.k-in:first', treeItem);
        var itemCountEl = $('.tvItemCount', kIn);

        if (!itemCountEl.length) {

            itemCountEl = $('<span/>', {

                'class': 'tvItemCount'
            }).appendTo(kIn);
        }

        if (count > 0) {

            itemCountEl.text(count);
        }
        else if (itemCountEl.length) {

            itemCountEl.remove();
        }

        if (updateData) {

            treeItem.data('count', count);
        }
    },
    highlightTreeItem: function (e) {

        e.element.find('.tvActive').removeClass('tvActive');
        var targ = e.element.find('.tvItem[data-key="{0}"]'.format(e.key));
        targ.addClass('tvActive').parents('.tvItem').addClass('tvActive');
    },
    highlightLastRouteInNavTree: function () {

        var ri = cafm.cache.get(cafm.res.consts.CacheKey_LastRouteInfo);

        if (ri) {
            cafm.treeView.highlightTreeItem({
                element: nav.getNavTree(),
                key: ri.navKey
            });
        }
    },
    loadOnDemandTreeDataBound: function (args) {

        var tvEl = args.sender.element,
            tvDs = args.sender.dataSource,
            o = tvEl.data('options'),
            newNodes = [],
            formatNode = function (nodeEl, node, isTop) {

                nodeEl.attr('data-itemtype', node.Type);
                nodeEl.attr('data-key', node.Id);

                nodeEl.addClass('tvItem');

                if (isTop) {
                    nodeEl.addClass('topTvItem');
                }

                nodeEl.addClass(node.Css);

                newNodes.push(nodeEl);
            }

        var node;
        // args.node will be set if a node was expanded
        if (args.node) {

            // get the uid
            var uid = args.node.data('uid');
            // now get the node by the uid
            node = tvDs.getByUid(uid);

            // if items are preloaded then just cycle them
            if (cafm.util.hasItem(node.Items)) {

                // cycle nodes
                node.Items.forEach(function (node) {

                    // get element
                    var nodeEl = tvEl.find('[data-uid="{0}"]'.format(node.uid));

                    // format node
                    formatNode(nodeEl, node);
                });
            }
            else {

                // otherwise cycle the node elements child item elements
                tvEl.find('[data-uid="{0}"] .k-item'.format(uid)).each(function (i, nodeEl) {

                    nodeEl = $(nodeEl);

                    // get the node using element uid
                    node = tvDs.getByUid(nodeEl.data('uid'));

                    // format node
                    formatNode(nodeEl, node);
                });
            }
        }
        // else it's the root item
        else {

            // get the node and it's element
            node = tvDs.data();

            if (node.length > 0) {

                tvOptions = tvEl.data('options');

                node.forEach(function (n) {

                    // format node
                    formatNode(tvEl.find('[data-uid="{0}"]'.format(n.uid)), n);
                })

                var nodeEl = tvEl.find('[data-uid="{0}"]'.format(node[0].uid));

                // expand the root node (if document/documentfolder tree)
                if(cafm.enums.isSingleEnumValue(o.Mode, [cafm.enums.TreeViewMode.DocumentFolderSelection, cafm.enums.TreeViewMode.DocumentSelection])) {

                    args.sender.expand(nodeEl);
                }

                // add standard cafm tree view class
                tvEl.addClass('cafmTv');

                // set top level purpose specific css, once only
                if (tvEl.data('class')) {

                    tvEl.addClass(tvEl.data('class'));
                    //tvEl.removeAttr('data-class');
                    //tvEl.removeData('class');
                }
            }
            else {

                args.sender.wrapper.showMessage({

                    title: cafm.res.str.TextNoItems
                });
            }
        }

        if (cafm.enums.isSingleEnumValue(o.Mode, [cafm.enums.TreeViewMode.DocumentFolderSelection, cafm.enums.TreeViewMode.DocumentSelection, cafm.enums.TreeViewMode.StandardWorkOrderSelection]) && isTouch) {
            
            $(newNodes).touchHold(function (e) {
                
                if (cafm.treeView.touchHoldId) {

                    return false;
                }

                var targ = $(e.currentTarget);
                setTimeout(function () {

                    targ.find('.k-state-hover').removeClass('k-state-hover')
                }, 1000);

                var itemType = targ.data('itemtype');

                if (cafm.enums.isSingleEnumValue(itemType, [cafm.enums.TreeViewItemType.DocumentFolder, cafm.enums.TreeViewItemType.StandardWorkOrderGroup])) {
                    
                    cafm.treeView.touchHoldId = targ.data('key');
                    args.sender.toggle(targ);

                    setTimeout(function () {
                        cafm.treeView.touchHoldId = null;
                    }, 500);
                }

                return false;
            });
        }

        cafm.util.callFunction(o.OnDataBound, args);
    },
    updateListItemCount: function (list, itemKey) {

        if (!isStr(itemKey)) {

            itemKey = cafm.enums.getEnumKey(cafm.enums.Navigatable, itemKey);
        }

        var activeFormCategorySelector = '.tvActive[data-key="{0}"]'.format(itemKey);
        var activeFormCategory = $(activeFormCategorySelector);
        var count = list.data('unfilteredTotal');

        if (!cafm.util.isNum(count)) {

            count = list.getListItemCount();
        }

        cafm.treeView.displayItemCount(activeFormCategory, count, true);
    }
}